import { useNavigate } from 'react-router-dom';
import { CONST_ROUTE_PATH } from '../../route/RouteConstants';

const LockIcon = () => (
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const SubscriptionLock = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      textAlign: 'center',
    }}>
      <div style={{ color: 'var(--brand, #ff6b2b)', opacity: 0.9 }}>
        <LockIcon />
      </div>
      <div style={{
        fontSize: '17px',
        fontWeight: 700,
        color: 'var(--text, #1a2035)',
      }}>
        Subscribe to view full data
      </div>
      <div style={{
        fontSize: '13px',
        color: 'var(--muted, #7a8499)',
        maxWidth: '300px',
        lineHeight: 1.6,
      }}>
        Unlock complete insights, recommendations, and resource details.
      </div>
      <button
        onClick={() => navigate(CONST_ROUTE_PATH.PRICING)}
        style={{
          marginTop: '4px',
          padding: '10px 28px',
          background: 'var(--brand, #ff6b2b)',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          letterSpacing: '0.02em',
          boxShadow: '0 4px 14px rgba(255,107,43,0.35)',
        }}
      >
        View Plans →
      </button>
    </div>
  );
};

export default SubscriptionLock;
